// Port of api/fuel/app/classes/model/log/user/initiated.php
import Model from 'offline/stream/model/base'
import Constants from 'offline/constants'

export default Model.extend({
	table: 'log_user_initiated',
	prefix: 'log',
	key: 'log_id',
	fields: {
		log_id: Model.SCHEMA_KEY,
		log_date: Model.SCHEMA_DATE_CREATE,
		user_id: Model.SCHEMA_NUMBER,
		log_initial_sync: Model.SCHEMA_NUMBER
	},
	methods: {
		get_type: function() { return Constants.LOG_TYPE_USER_INITIATED },
		to_array: function() {
			return {
				id: +this.get_id(),
				user: +this.get_user_id(),
				date: +this.get_date(),
				type: +this.get_type()
			}
		}
	}
})
